.dmProductDetailsRowContainer {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 48px;
}
